<template>
  <div :class="{ 'animate-pulse': !isError }">
    <div
      class="rounded-full"
      :class="[isError ? 'bg-critical-secondary-press' : 'bg-neutral-quinary']"
      :style="{ width, height }"
    />
  </div>
</template>

<script setup lang="ts">
type TextSkeletonProps = {
  isError?: boolean;
  width?: string;
  height?: string;
};

withDefaults(defineProps<TextSkeletonProps>(), {
  isError: false,
  height: '11px',
  width: '90px',
});
</script>
